const Business = () => {
    return (

        // <div className="container-fluid bg-light overflow-hidden my-5 px-lg-0">
            <div className="container feature px-lg-0">
                <div className="row mx-lg-0">
                    <div className="col-lg-6 feature-text py-6 wow fadeIn" data-wow-delay="0.1s">
                        <div className="p-lg-6 ps-lg-0">
                            {/*<h6 className="text-primary">Methodology overview</h6>*/}
                            <h1 className="mb-4">BUSINESS PROPOSITION TO ALL WHO CAN BE INTERESTED</h1>
                            <p className="text-xl-start" >
                                As a result of R&D the method of definition the real process of physical damage accumulation for any material individually was developed.  However, damage accumulation rule directly depends from accuracy of S-N curve. In order to avoid negative influence dispersion of S-N curve STEDAX developed method correction of S-N curve (avoiding any dispersion and increasing accuracy) using KTSM Rule. Now we are ready to provide this kind of service to users of any fatigue analysis software and developers of this kind software as well.
                                In order to provide this service we have to get from customer parameters of S-N curve as input data for our processing.

                            </p>
                        </div>
                    </div>
                    <div className="col-lg-6 pe-lg-0 wow fadeIn" data-wow-delay="0.5s">
                        <div className="position-relative h-100 align-content-center">
                            <img className="position-absolute img-fluid w-70 h-100" src="img/fatigue_graph.png" alt=""></img>
                        </div>
                    </div>
                </div>
            </div>
        // </div>

    )
}

export default Business;